// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul li[data-v-877f14f0]{margin:.3rem}ul li a[data-v-877f14f0]{font-size:.26rem;color:#007aff;text-decoration:none}", ""]);
// Exports
module.exports = exports;
